import React, { forwardRef, useEffect, useRef } from "react";
import bwipjs from "bwip-js";
import { QRCodeCanvas } from "qrcode.react";
import Logo from "../images/logo2.png";

const WaybillPrint = forwardRef(({ order }, ref) => {
  const barcodeCanvasRef = useRef(null);
  const [globalThreshold, setGlobalThreshold] = React.useState(2000);
  const [defaultShippingCost, setDefaultShippingCost] = React.useState(350);
  
  const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";




  useEffect(() => {
    if (barcodeCanvasRef.current && order?.trackingNumber) {
      try {
        bwipjs.toCanvas(barcodeCanvasRef.current, {
          bcid: "code128",
          text: order.trackingNumber,
          scale: 2,
          height: 8,
          includetext: true,
          textxalign: "center",
        });
      } catch (err) {
        console.error("Barcode rendering failed", err);
      }
    }
    
    // Fetch global settings
    Promise.all([
      fetch(`${BASE_URL}/api/settings/freeDeliveryThreshold`).then(res => res.json()),
      fetch(`${BASE_URL}/api/settings/defaultShippingCost`).then(res => res.json())
    ])
    .then(([thresholdData, shippingData]) => {
      if (thresholdData && thresholdData.value) {
        setGlobalThreshold(parseFloat(thresholdData.value));
      }
      if (shippingData && shippingData.value) {
        setDefaultShippingCost(parseFloat(shippingData.value));
      }
    })
    .catch(err => console.error("Failed to fetch global settings", err));
      
  }, [order, BASE_URL]);







  if (!order) return null;

  return (
    <div
      ref={ref}
      className="printable"
      style={{
        width: "4in",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        padding: "0",
        margin: "0",
        color: "#000"
      }}
    >

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", border: "1px solid #ccc", padding: "10px" }}>
        <img src={Logo} alt="FDE Logo" style={{ height: "50px" }} />
        <div style={{ fontWeight: "bold" }}>Waybill ID : {order.trackingNumber}</div>
      </div>

      {/* Recipient Details */}
      <div style={{ border: "1px solid #ccc", borderTop: "none", padding: "10px" }}>
        <h4 style={{ marginBottom: "6px" }}>Recipient Details</h4>
        <p>Name: {order.customerName}</p>
        <p>Address: {order.addressLine1}, {order.addressLine2}, {order.city}</p>
        <p>Contact No: {order.phone}</p>
      </div>

      {/* Pickup Details */}
      <div style={{ border: "1px solid #ccc", borderTop: "none", padding: "10px" }}>
        <h4 style={{ marginBottom: "6px" }}>Pickup Details</h4>
        <p>Name: ReeBonn Lanka (Pvt) Ltd</p>
        <p>Address: No. 437 B 1, Pannipitiya Road</p>
        <p>Contact No: 772153163</p>
        <p>Weight: 1kg</p>
        <p>Order ID: {order.orderId}</p>
      </div>

      {/* COD + Barcode/QR */}
      <div style={{ border: "1px solid #ccc", borderTop: "none", padding: "10px", textAlign: "center" }}>
        {(() => {
          const subTotal = order.subTotal || 0;
          const shipping = order.shippingCost !== undefined ? order.shippingCost : (subTotal < globalThreshold ? (order.originalShippingCost || defaultShippingCost) : 0);
          const totalCOD = order.total || (subTotal + shipping);

          return (
            <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
              COD : Rs. {totalCOD.toFixed(2)} LKR
            </div>
          );
        })()}

        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginTop: "10px" }}>
          <QRCodeCanvas value={order.trackingNumber} size={90} />
          <canvas
            ref={barcodeCanvasRef}
            width={150}
            height={40}
            style={{ display: "block", marginTop: "10px", objectFit: "contain" }}
          />
        </div>
      </div>

    </div>
  );
});

export default WaybillPrint;
